var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 3.33105C5.85659 3.33105 2.49686 6.13112 2.49686 9.58124C2.55949 11.6632 3.7077 13.5603 5.52312 14.5814C5.34279 15.0714 5.09203 15.5326 4.77876 15.9504C4.60585 16.2028 4.61012 16.5367 4.78944 16.7846C4.96876 17.0326 5.28449 17.1412 5.57839 17.056C6.58075 16.7642 7.52421 16.2989 8.36597 15.6814C8.90475 15.7824 9.45182 15.8326 9.99998 15.8314C14.1434 15.8314 17.5031 13.0314 17.5031 9.58124C17.5031 6.13113 14.1434 3.33105 9.99998 3.33105Z",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49893 8.33286H12.501",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49893 10.8338H9.99997",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessage);
export default __webpack_public_path__ + "static/media/chat-message.65687894150e2028e43a6580a38b08f8.svg";
export { ForwardRef as ReactComponent };